<h1 mat-dialog-title>
  {{ 'EDITOR.ADDSYMBOL' | translate }} <mat-icon class="abort" (click)="abort()">close</mat-icon>
</h1>

<mat-dialog-content class="content">
  @if (symbols) {
    <mat-tab-group>
      @for (group of symbols; track group) {
        <mat-tab [label]="group.text">
          <div class="group">
            @for (item of group.items; track item) {
              <div (click)="select(item)" class="symbol">
                <div class="image"><img [src]="item.imageData" /></div>
                <div class="image-text">{{ item.text }}</div>
              </div>
            }
          </div>
        </mat-tab>
      }
    </mat-tab-group>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button (click)="abort()" mat-button [mat-dialog-close]="true" cdkFocusInitial>
    {{ 'DIALOGS.CANCEL' | translate }}
  </button>
</mat-dialog-actions>
